<template>
  <ActionCardPreview v-bind="previewProps" icon="签" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import ActionCardPreview from '../../ActionCardPreview.vue'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()
const previewProps = computed(() => props)
</script>
